// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__64TjJ","box":"WorkspacesBox_box__2i6S-","node":"WorkspacesBox_node__1m68F"};